var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCsMarkerPoi = function SvgCsMarkerPoi(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 55,
    viewBox: "0 0 49 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1443_7210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.728 9.27199C40.0326 12.5763 41.9227 17.0362 41.9984 21.7088C42.0742 26.3814 40.3298 30.9003 37.134 34.31L36.728 34.73L28.242 43.214C27.1652 44.29 25.5214 45.4499 24 45.5C22.4785 45.5501 21.1932 44.4868 20.048 43.484L19.76 43.214L11.272 34.728C7.89631 31.3523 5.99988 26.7739 5.99988 22C5.99988 17.2261 7.89631 12.6477 11.272 9.27199C14.6477 5.89631 19.2261 3.99988 24 3.99988C28.7739 3.99988 33.3523 5.89631 36.728 9.27199Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9753 20.4909V9.73645L14 27.1381H23.945L23.945 37.8925L33.7855 20.4909L23.9753 20.4909Z",
    fill: "url(#paint0_linear_1443_7210)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1443_7210",
    x: 0.999878,
    y: 0.999878,
    width: 48.001,
    height: 53.5018,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.219608 0 0 0 0 0.262745 0 0 0 0 0.419608 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1443_7210"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1443_7210",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1443_7210",
    x1: 23.8928,
    y1: 9.73645,
    x2: 23.8928,
    y2: 37.8925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1565C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2196F3"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCsMarkerPoi);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "csMarkerPOI.ab3f2e2e4366ed04809c20c40ff966fd.svg";